/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { AdminDeposit } from 'src/core/models'
import React, { useState, useEffect } from 'react'
import { adminDepositsSelector } from 'src/features'
import { getAdminDepositsFiltered } from 'src/core/helpers'
import { useAppSelector, useWindowSize } from 'src/app/hooks'
import { adminDepositListColumns } from 'src/core/table-columns'
import ValidateDepositsListHeader from './ValidateDepositsListHeader/ValidateDepositsListHeader'
import { CustomSeo, CustomCol, GoBackLink, PageTitle, CustomCard, CustomTable } from 'src/components'

const ValidateDepositsPageContent: React.FC = () => {
  const { t } = useTranslation()
  const { data: depositsList, loading } = useAppSelector(adminDepositsSelector)
  const { isMobile } = useWindowSize()
  const [filterText, setFilterText] = useState<string>(null)
  const [filteredDeposits, setFilteredDeposits] = useState<AdminDeposit[]>(depositsList)

  // Manage Filtering
  useEffect(() => {
    const newList = getAdminDepositsFiltered(depositsList, filterText)
    setFilteredDeposits(newList)
  }, [filterText, depositsList])

  return <>
    {/* Seo */}
    <CustomSeo title={t('My ClimateTrade: Validate Deposits')} />

    {/* Page Header */}
    <Row>
      <CustomCol>
        <GoBackLink link={'/admin'} label={t('Validate.GoBack')} />
      </CustomCol>
      <CustomCol>
        <div className={isMobile ? 'centered-div' : 'float-right'}>
          <PageTitle>{t('ValidateDeposits.Title')}</PageTitle>
        </div>
      </CustomCol>
    </Row>

    {/* Transfers List */}
    <CustomCard loading={loading}>
      <ValidateDepositsListHeader
        filterText={filterText}
        quantity={filteredDeposits.length}
        setFilterText={(value) => setFilterText(value)}
      />
      <Divider />
      <CustomTable
        pageSize={10}
        dataSource={filteredDeposits}
        columns={adminDepositListColumns}
        rowClassName={() => 'fade-animation'}
        rowKey={(deposit: AdminDeposit) => deposit.id}
      />
    </CustomCard>
  </>
}

export default ValidateDepositsPageContent
